export default "__VITE_ASSET__2a124802__"